import { createId } from "@paralleldrive/cuid2";

const BLOCKED_SQID_VALUES = new Set([
	"",
	"anonymous",
	"email",
	"null",
	"undefined",
	"true",
	"false",
]);

export function mintSqid(): string {
	for (let attempt = 0; attempt < 5; attempt += 1) {
		const sqid = `sq_${createId()}`;
		if (assertSqidAllowedForPosthog(sqid)) {
			return sqid;
		}
	}
	throw new Error("Failed to mint a PostHog-safe sqid");
}

export function assertSqidAllowedForPosthog(sqid: string): boolean {
	const normalized = sqid.trim().toLowerCase();
	if (!normalized || BLOCKED_SQID_VALUES.has(normalized)) {
		return false;
	}
	if (normalized.includes("@")) {
		return false;
	}
	return true;
}

export function resolvePostHogDistinctId(sqid: string): string {
	if (!assertSqidAllowedForPosthog(sqid)) {
		throw new Error("Invalid sqid for PostHog distinct_id");
	}
	return sqid;
}
